import { find, flatMap, get, groupBy, mapValues, sortBy } from 'lodash';

const generateGroups = (contests, entries, options = {}) => {
  // TODO: Make a config option for for maximumGroupSize/maximumSessionSize.
  const { groupSizes = [18] } = options;

  const groupedEntries = groupBy(entries, 'contest.id');

  const sortedEntries = mapValues(groupedEntries, entries =>
    sortBy(entries, [
      ({ total }) => -total, // Higher total first.
      ({ lotNumber }) => lotNumber, // Lower lot number first.
    ]),
  );

  const groups = flatMap(sortedEntries, (entries, contestId) => {
    const groups = [];

    if (contestId === 'undefined') contestId = undefined;

    const remainingEntries = [...entries];
    for (let i = 0; remainingEntries.length; ++i) {
      const groupSize = groupSizes[i] || groupSizes.slice(-1)[0];
      const letter = String.fromCharCode('A'.charCodeAt() + i);

      const groupEntries = remainingEntries.splice(0, groupSize);
      const contest = find(contests, { id: Number(contestId) });

      groups.unshift({
        contest: get(contest, 'primaryKey'),
        letter,
        entries: groupEntries.map(({ primaryKey }) => primaryKey),
      });
    }
    return groups;
  });

  const orderedGroups = sortBy(groups, 'letter');

  let nextOrder = 1;
  for (const group of orderedGroups) group.order = nextOrder++;

  return orderedGroups;
};

export default generateGroups;



// WEBPACK FOOTER //
// ./src/pages/Schedule/generateGroups.js